import React from "react";
import css from "./loader-table.module.scss";

const LoaderTable = () => {
  return <div className={css.cntloaderTable} />;
};

export default LoaderTable;
